import { sessionManager } from "core/instances";
import UserPermissionsManager from "core/lib/user-permissions.manager";
import User from "core/models/user";
import { Agreement } from "core/services/cef/types";

export type InviteUserRequest = {
    firstName: string,
    lastName: string,
    email: string,
    phone: string,
    grantValues: Array<number>,
    role: string
}

export type ApproveUserRequest = {
    firstName: string,
    lastName: string,
    childCiamId: string,
    grantValues: Array<number>,
    role: string
}

export class UserPermissionsRequest {
    businessUnit = "DStv";
    customerNumber = sessionManager.loggedInUser?.customerNumber;
    companyName = User.instance?.company?.companyName;
    email?: string;
    phone?: string;
    firstName?: string;
    lastName?: string;
    childCiamId?: string;
    status?: string;
    agreements?: any;
    role?: string;

    //Primary inviting child user
    async invite(request: InviteUserRequest) {
        const { firstName, lastName, email, phone, grantValues, role } = request;

        this.firstName = firstName;
        this.lastName = lastName;
        this.email = email;
        this.phone = phone;
        this.role = role;

        await this._populatePermissions(grantValues);

        return this;
    }

    //Primary approving child user
    async approval(request: ApproveUserRequest) {
        const { firstName, lastName, childCiamId, grantValues, role } = request;

        this.firstName = firstName;
        this.lastName = lastName;
        this.childCiamId = childCiamId;
        this.status = "Active";
        this.role = role;

        await this._populatePermissions(grantValues);

        return this;
    }

    //Child user accepting invite/ independent register
    registerChild(customerNumber: number, isInvite = false) {
        this.customerNumber = customerNumber;

        if (isInvite) {
            this.status = "Active";
        }

        return this;
    }

    private async _populatePermissions(grantValues: Array<any>) {
        const primaryAgreement = User.instance?.accountDetails;

        const permissions = await UserPermissionsManager.getFilteredPermissions(grantValues);

        const agreement: Agreement = {
            id: primaryAgreement.id,
            friendlyName: primaryAgreement.friendlyName,
            permissions: permissions
        }

        this.agreements = [agreement];
    }
}
